const features = [
  {
    icon: 'ri-book-read-line',
    title: '海量免费资源',
    desc: '收录 5000+ 部耽美漫画与 BL 漫画，全站永久免费，无需付费会员，无需注册登录，打开即读，真正零门槛畅享耽美漫画世界。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清阅读体验',
    desc: '全站漫画采用高清画质呈现，自适应多种设备屏幕尺寸，手机、平板、电脑均能获得流畅细腻的漫画阅读体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日准时更新',
    desc: '运营团队每日精选优质新作入库，热门连载同步作者更新节奏，让读者每天都能发现新鲜的免费耽美漫画内容不重样。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步阅读',
    desc: '无论你在通勤路上用手机、午休时用平板、还是在家用电脑，耽美漫画网自适应排版确保各设备一致的舒适阅读感受。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500">耽美漫画网为你打造的专属免费阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg p-5 md:p-6 text-center group hover:bg-primary-50/50 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}